(function (root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  api.boot(root);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ninte-dynamic-variant-title-root]';
  var TITLE_SELECTOR = '[data-ninte-dynamic-variant-title]';
  var OPTION_SELECTOR = '.single-option-selector[data-index]';
  var STICKY_SELECTOR = '[data-sticky-add-to-cart]';
  var STICKY_SWATCH_SELECTOR = '.pr-swatch[data-value]';
  var STICKY_ACTIVE_SELECTOR = '.pr-active[data-value]';
  var states = new WeakMap();

  function clean(value) {
    return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
  }

  function normalizeValues(values) {
    return (values || []).map(clean).filter(function (value) {
      return value && value !== 'Default Title';
    });
  }

  function buildTitle(baseTitle, values) {
    var base = clean(baseTitle);
    var parts = normalizeValues(values);
    if (!base || !parts.length) return '';
    return [base].concat(parts).join(' – ');
  }

  function variantValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) {
      return normalizeValues(variant.options);
    }
    return normalizeValues([
      variant.option1,
      variant.option2,
      variant.option3
    ]);
  }

  function optionPosition(node) {
    var match = /^option(\d+)$/.exec(clean(node.getAttribute('data-index')));
    return match ? parseInt(match[1], 10) : null;
  }

  function selectedValues(container) {
    var seen = {};
    var selected = {};
    var nodes = container.querySelectorAll(OPTION_SELECTOR);
    var positions;

    Array.prototype.forEach.call(nodes, function (node) {
      var position = optionPosition(node);
      var type;
      var value;

      if (position == null) return;
      seen[position] = true;
      type = clean(node.getAttribute('type')).toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !node.checked) return;

      value = clean(node.value);
      if (!value || value === 'Default Title') return;
      selected[position] = value;
    });

    positions = Object.keys(seen)
      .map(function (value) { return parseInt(value, 10); })
      .sort(function (a, b) { return a - b; });

    if (!positions.length) return [];
    if (positions.some(function (position) { return !selected[position]; })) {
      return [];
    }
    return positions.map(function (position) { return selected[position]; });
  }

  function renderValues(container, values) {
    var titleNode = container.querySelector(TITLE_SELECTOR);
    var nextTitle;

    if (!titleNode) return '';
    nextTitle = buildTitle(
      titleNode.getAttribute('data-base-title'),
      values
    );
    if (!nextTitle) return '';
    if (titleNode.textContent !== nextTitle) {
      titleNode.textContent = nextTitle;
    }
    return nextTitle;
  }

  function sectionId(container) {
    return clean(container.getAttribute('data-section-id'));
  }

  function findSticky(root, container) {
    var expectedSection = sectionId(container);
    var nodes;
    var index;

    if (!expectedSection || !root.document.querySelectorAll) return null;
    nodes = root.document.querySelectorAll(STICKY_SELECTOR);
    for (index = 0; index < nodes.length; index += 1) {
      if (
        clean(nodes[index].getAttribute('data-ninte-variant-section')) ===
        expectedSection
      ) {
        return nodes[index];
      }
    }
    return null;
  }

  function variantIndex(root, state) {
    var node;
    var product;
    var index;

    if (state.variantIndex) return state.variantIndex;
    if (!state.sectionId || !root.document.getElementById) return null;
    node = root.document.getElementById('ProductJson-' + state.sectionId);
    if (!node) return null;

    try {
      product = JSON.parse(node.textContent || '');
    } catch (error) {
      return null;
    }
    if (!product || !Array.isArray(product.variants)) return null;

    index = Object.create(null);
    product.variants.forEach(function (variant) {
      if (variant && variant.id != null) {
        index[String(variant.id)] = variant;
      }
    });
    state.variantIndex = index;
    return index;
  }

  function stickyValues(root, state) {
    var active;
    var id;
    var index;

    if (!state.sticky) return [];
    active = state.sticky.querySelector(STICKY_ACTIVE_SELECTOR);
    if (!active) return [];
    id = clean(active.getAttribute('data-value'));
    if (!id) return [];
    index = variantIndex(root, state);
    if (!index || !index[id]) return [];
    return variantValues(index[id]);
  }

  function closestWithin(node, selector, boundary) {
    var current = node;
    while (current && current !== boundary) {
      if (current.matches && current.matches(selector)) return current;
      current = current.parentNode;
    }
    return null;
  }

  function requestFrame(root, callback) {
    if (typeof root.requestAnimationFrame === 'function') {
      return {
        kind: 'raf',
        id: root.requestAnimationFrame(callback)
      };
    }
    return {
      kind: 'timeout',
      id: root.setTimeout(callback, 0)
    };
  }

  function cancelPending(root, state) {
    if (!state.ticket) return;
    if (
      state.ticket.kind === 'raf' &&
      typeof root.cancelAnimationFrame === 'function'
    ) {
      root.cancelAnimationFrame(state.ticket.id);
    } else {
      root.clearTimeout(state.ticket.id);
    }
    state.ticket = null;
  }

  function schedule(root, state, readValues) {
    var epoch;

    cancelPending(root, state);
    state.epoch += 1;
    epoch = state.epoch;
    state.ticket = requestFrame(root, function () {
      var values;
      state.ticket = null;
      if (states.get(state.container) !== state) return;
      if (state.epoch !== epoch) return;
      values = normalizeValues(readValues());
      if (!values.length) return;
      renderValues(state.container, values);
    });
  }

  function bind(root, container) {
    var state;

    if (!root || !root.document || !container) return false;
    if (states.has(container)) return true;
    if (!container.querySelector(TITLE_SELECTOR)) return false;

    state = {
      container: container,
      sectionId: sectionId(container),
      sticky: null,
      variantIndex: null,
      ticket: null,
      epoch: 0,
      mainHandler: null,
      stickyHandler: null
    };

    state.mainHandler = function (event) {
      if (!closestWithin(event && event.target, OPTION_SELECTOR, container)) {
        return;
      }
      schedule(root, state, function () {
        return selectedValues(container);
      });
    };
    container.addEventListener('change', state.mainHandler, true);

    state.sticky = findSticky(root, container);
    if (state.sticky) {
      state.stickyHandler = function (event) {
        if (
          !closestWithin(
            event && event.target,
            STICKY_SWATCH_SELECTOR,
            state.sticky
          )
        ) {
          return;
        }
        schedule(root, state, function () {
          return stickyValues(root, state);
        });
      };
      state.sticky.addEventListener('click', state.stickyHandler, true);
    }

    states.set(container, state);
    schedule(root, state, function () {
      return selectedValues(container);
    });
    return true;
  }

  function rootsWithin(scope) {
    var roots = [];
    if (!scope) return roots;
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(
        scope.querySelectorAll(ROOT_SELECTOR)
      ));
    }
    return roots;
  }

  function init(root, scope) {
    var count = 0;
    rootsWithin(scope || root.document).forEach(function (container) {
      if (bind(root, container)) count += 1;
    });
    return count;
  }

  function unbind(root, scope) {
    rootsWithin(scope).forEach(function (container) {
      var state = states.get(container);
      if (!state) return;

      cancelPending(root, state);
      container.removeEventListener('change', state.mainHandler, true);
      if (state.sticky && state.stickyHandler) {
        state.sticky.removeEventListener('click', state.stickyHandler, true);
      }
      states.delete(container);
    });
  }

  function boot(root) {
    var started = false;

    if (!root || !root.document) return;

    function start() {
      if (started) return;
      started = true;
      init(root, root.document);
    }

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', start, { once: true });
      if (root.addEventListener) {
        root.addEventListener('load', start, { once: true });
      }
    } else {
      start();
    }

    root.document.addEventListener('shopify:section:load', function (event) {
      init(root, event.target);
    });
    root.document.addEventListener('shopify:section:unload', function (event) {
      unbind(root, event.target);
    });
  }

  return {
    normalizeValues: normalizeValues,
    buildTitle: buildTitle,
    variantValues: variantValues,
    selectedValues: selectedValues,
    renderValues: renderValues,
    bind: bind,
    init: init,
    unbind: unbind,
    boot: boot
  };
}));
